import { IProjectTeamRegistry, IProjectTeamRepository } from "../../../domain/projectTeam";
import { ProjectTeamRepository } from ".";

export class ProjectTeamRegistry implements IProjectTeamRegistry {
  constructor(private _getToken: () => string) {
  }
  
  getProjectTeamRepository(): IProjectTeamRepository {
    return new ProjectTeamRepository(this._getToken);
  }
}
